<template>
  <div>
    <div id="url_valid">
      <div id="Display_page">
        <br />
        <div class="container is-fluid has-text-centered" id="url_expired">
          <h4>Welcome to Doodhvale, Please wait...</h4>
        </div>
        <div v-if="!failMessage">
          <div v-if="!successMessage">
            <div id="url_valid">
              <div>
                <center>
                  <img
                    :src="apiDataObj.image_url ? apiDataObj.image_url : ''"
                  />
                  <b
                    ><h3>{{ apiDataObj.header }}</h3></b
                  >
                  <p class="discription">{{ apiDataObj.offer_detail }}</p>

                  <form>
                    <b
                      ><button
                        class="subs"
                        type="button"
                        v-on:click="place_order()"
                        style="
                          background-color: #74c7fc;
                          border: none;
                          size: 3px;
                          color: #ffffff;
                          border-radius: 4px;
                          text-align: center;
                        "
                      >
                        {{ apiDataObj.button_caption }}
                      </button></b
                    >
                  </form>
                </center>
                <br />
              </div>
            </div>
          </div>
        </div>

        <div v-if="successMessage" class="success-message">
          <center>
            <img class="msg-icon" src="static/img/icons/thumb-up.png" />
            <br />
            <p class="messg">{{ successMessage }}</p>
          </center>
        </div>

        <div v-if="failMessage" class="fail-message">
          <center>
            <img class="msg-icon" src="static/img/icons/warning.png" />
            <br />
            <p class="messg">{{ failMessage }}</p>
          </center>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      imgPreUrl: "https://doodhvale.in",
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      isLoading: true,
      isLoaded: false,
      successMessage: "",
      failMessage: "",
      isFullPage: true,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      const params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split("Free_order?");
      params.append("url_str", splitUrl[1]);
      axios({
        url: process.env.BASE_API + "/accounts/fetch-url-interface-data",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          this.urlInterface = {};
          if (
            response.data.status === "000001" ||
            response.data.status === "000002" ||
            response.data.status === "000003"
          ) {
            this.urlInterface.error_msg = response.data.msg;
            document.getElementById("url_valid").style.display = "none";
          } else {
            document.getElementById("url_expired").style.display = "none";
            this.urlInterface.action_name = response.data.action_name;
            this.urlInterface.url_interface_id = response.data.url_interface_id;
            this.invokeUrlAction();
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === "SUCCESS") {
            this.list = response.data.user_record;
            alert(this.list);
          }
        })
        .catch((e) => {
          alert("1234");
        });
      this.invokeUrlAction();
    },
    invokeUrlAction() {
      const params = new URLSearchParams();
      params.append("url_interface_id", this.urlInterface.url_interface_id);
      params.append("action_name", this.urlInterface.action_name);
      axios({
        url: process.env.BASE_API + "/accounts/invoke-url-action",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          this.apiDataObj = {};
          switch (this.urlInterface.action_name) {
            case "order_free_product":
              this.apiDataObj.userId = response.data.action_response.user_id;
              this.apiDataObj.product_id =
                response.data.action_response.product_id;
              this.apiDataObj.image_url =
                response.data.action_response.image_url;
              this.apiDataObj.header = response.data.action_response.header;
              this.apiDataObj.offer_detail =
                response.data.action_response.offer_detail;
              this.apiDataObj.button_caption =
                response.data.action_response.button_caption;
              this.apiDataObj.action_name = this.urlInterface.action_name;
              // console.log(response);
              // this.userInfo()
              break;
            default:
              break;
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === "SUCCESS") {
            // alert("ok");
          }
        })
        .catch((e) => {
          // alert("not ok");
        });
    },
    place_order() {
      const params = new URLSearchParams();
      params.append("user_id", sessionStorage.getItem("userId"));
      params.append("product_id", this.productId);
      params.append("url_interface_id", this.urlInterface.url_interface_id);
      params.append("action_name", this.urlInterface.action_name);
      axios({
        url: process.env.BASE_API + "/accounts/update-url-user-response",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          if (response.data.status === "000000") {
            this.successMessage = response.data.msg;
            this.failMessage = ""; // Clear fail message
          } else {
            this.successMessage = ""; // Clear success message
            this.failMessage = response.data.msg;
          }
        })
        .catch((e) => {
          this.successMessage = "";
          this.failMessage = "Error occurred while placing the order.";
        });
    },
  },
};
</script>

  <style>
.discription,
.messg {
  text-align: center;
  margin-bottom: 20px;
}
.messg {
  font-size: 20px;
}
.success-message {
  color: green;
  margin-top: 10px;
}

.fail-message {
  color: red;
  margin-top: 10px;
}
.loading-icon:before {
  content: "Wait...";
  color: black;
}
.loading-overlay .loading-icon:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #3cb6c3;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  height: 1em;
  position: relative;
  width: 1em;
  position: absolute;
  top: calc(50% - 1.5em);
  left: calc(50% - 1.5em);
  width: 3em;
  height: 3em;
  border-width: 0.25em;
}
ul {
  list-style: initial;
}
body,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6,
b,
input,
button,
select,
optgroup,
textarea,
article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section,
a {
  font-family: Calibari !important;
}
.msg-icon {
  max-width: 60px;
  height: auto;
}
@media (max-width: 550px) {
  .discription {
    width: 85%;
    text-align: center;
  }
  .messg {
    width: 80%;
  }
}
.disagree,
.subs {
  padding: 2% 17% 2% 17%;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Free_order.vue